import Aside from './Aside.vue'
import Breadcrumb from './Breadcrumb.vue'
import Callout from './Callout.vue'
import Footer from './Footer.vue'
import Header from './Header.vue'
import Sidebar from './Sidebar.vue'
import Switch from './Switch.vue'
import Statsbox from './Statsbox.vue'
import Table from './Table.vue'
import Chat from './Chat.vue'
import Charts from './Charts.vue'
import DateSelection from './DateSelection.vue'
import DateSelectionPie from './DateSelectionPie.vue'
import InteractionsTable from './InteractionsTable.vue'
import IntentTable from './IntentTable.vue'
import ConversationTopicTable from './ConversationTopicTable.vue'

export default {
  install(Vue) {
    Vue.component(Aside.name, Aside)
    Vue.component(Breadcrumb.name, Breadcrumb)
    Vue.component(Callout.name, Callout)
    Vue.component(Footer.name, Footer)
    Vue.component(Header.name, Header)
    Vue.component(Sidebar.name, Sidebar)
    Vue.component(Sidebar.name, Sidebar)
    Vue.component(Switch.name, Switch)
    Vue.component(Statsbox.name, Statsbox)
    Vue.component('line-chart', Charts)
    Vue.component(Table.name, Table)
    Vue.component(Chat.name, Chat)
    Vue.component(DateSelection.name, DateSelection)
    Vue.component(DateSelectionPie.name, DateSelectionPie)
    Vue.component(IntentTable.name, IntentTable)
    Vue.component(InteractionsTable.name, InteractionsTable)
    Vue.component(ConversationTopicTable.name, ConversationTopicTable)
  },
}



// WEBPACK FOOTER //
// ./src/components/index.js